<template>
  <b-row class="px-4 mb-3">
    <b-col sm="12" class="result-summary-flex rounded">
      <!-- {{params}} -->
      <div class="d-sm-flex justify-content-between">
        <div class="mx-2">
          <span class="tag-details"><translate>Destination</translate>: </span> <span class="name-details">{{params.resortName}}</span>
        </div>
        <div class="mx-2">
          <span class="tag-details"><translate>Check in</translate>: </span> <span class="name-details">{{ model.params.checkIn }}</span>
        </div>
        <div class="mx-2">
          <span class="tag-details"><translate>No of nights</translate>: </span> <span class="name-details">{{duration}}</span>
        </div>
        <div v-for="(room, index) in params.rooms" :key="index" class="mx-2">
          <span class="tag-details"><translate>Room</translate> {{index + 1 }} - </span>
          <span>{{room.adults}} </span><span class="name-details"> adulti</span>
          <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} copii</span>
        </div>
      </div>
      <hr class="my-1"/>
      <div>
       <small class="float-right">
          <b v-translate>generated by</b> -
          <span class="name-details"> {{userData.fname}} {{userData.lname}}</span>
       </small>
     </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import auth from 'b2b-common/mixins/auth'
import model from '../services/model'

export default {
  props: ['params'],
  mixins: [auth],
  data () {
    return {
      model
    }
  },
  computed: {
    duration () {
      return moment(model.params.checkOut, 'DD-MM-YYYY').startOf('day').diff(moment(model.params.checkIn, 'DD-MM-YYYY').startOf('day'), 'days')
    }
  }
}
</script>
